
import React, {useState, useEffect} from 'react';
import InputRange from 'react-input-range';
import {useSpring, animated /*config*/} from 'react-spring'
import 'react-input-range/lib/css/index.css';
import CurtainIcon from '../../../assets/img/dashboard/curtainIcon';
const CurtainType = ({selectedItem, handlePostData, action}) => {
	const [percentState, setPercentState] = useState(Number(selectedItem.deviceState.percentState)); // 해당 아이템의 퍼센트 상태
	const [percentage1, setPercentage1] = useState(100 - percentState); // 왼쪽 커튼 기준
	const [percentage2, setPercentage2] = useState(percentState); // 오른쪽 커튼 기준
	// percentage1과 2는 대칭
	const [width, setWidth] = useState(100 - percentState); // 커튼 크기
	const [, setWork] = useState(selectedItem.deviceState.workState);
	
	// useEffect(() => {
	// 	initBoth(Number(selectedItem.deviceState.percentState));
	// },[selectedItem.deviceState.percentState])

	useEffect(() => {
		const percent = Number(selectedItem.deviceState.percentState);
		setPercentState(percent); // 오른쪽 기준
		setPercentage1(100 - percent); // 왼쪽
		setPercentage2(percent); // 오른쪽
		setWidth(100 - percent);
		handleTransition('no-transition')
	},[selectedItem.deviceState.percentState])

	// 왼쪽 커튼 100~0. 왼쪽을 움직이면 오른쪽도 대칭적으로 움직여야 하니
	const handleCurtain1 = (value) => {
		setPercentage1(value) // 왼쪽은 해당 값
		setPercentage2(100 - value) // 오른쪽은 100-해당값 => 대칭
		setPercentState(100 - value); // 오른쪽이 0~100이니 해당 퍼센트가 기준
		handleTransition('transition')
		document.getElementsByClassName('input-range__slider')[0].style.transform = 'scale(1.3)'; // 변경시 버튼 크기 키움
		document.getElementsByClassName('input-range__slider')[1].style.transform = 'scale(1.3)'; // 변경시 버튼 크기 키움
		action();
	}
	// 오른쪽 커튼 0~100
	const handleCurtain2 = (value) => {
		setPercentage1(100 - value); // 왼쪽은 100-해당값 => 대칭
		setPercentage2(value); // 오른쪽은 해당 값
		setPercentState(value); // 오른쪽이 0~100이니 해당 퍼센트가 기준
		handleTransition('transition')
		document.getElementsByClassName('input-range__slider')[1].style.transform = 'scale(1.3)'; // 변경시 버튼 크기 키움
		document.getElementsByClassName('input-range__slider')[0].style.transform = 'scale(1.3)'; // 변경시 버튼 크기 키움
		action();
	}

	const handleComplete1 = () =>{ // 이벤트 완료시
		setWidth(100 - percentState) // 커튼 크기 설정
		handleTransition('transition')
		document.getElementsByClassName('input-range__slider')[0].style.transform = 'scale(1)'; // 변경 완료시 버튼 크기 원래대로
		document.getElementsByClassName('input-range__slider')[1].style.transform = 'scale(1)'; // 변경 완료시 버튼 크기 원래대로

		handlePostData("percentControl", percentState) // 해당 퍼센트로 커텐 이동

		action();
	}

	const handleComplete2 = () =>{ // 이벤트 완료시
		setWidth(100 - percentState) // 커튼 크기 설정
		handleTransition('transition')
		document.getElementsByClassName('input-range__slider')[0].style.transform = 'scale(1)'; // 변경 완료시 버튼 크기 원래대로
		document.getElementsByClassName('input-range__slider')[1].style.transform = 'scale(1)'; // 변경 완료시 버튼 크기 원래대로
	
		handlePostData("percentControl", percentState) // 해당 퍼센트로 커텐 이동
		
		action();
	}
	const handleWork = (state) => { // 커튼 열고 닫기, 100/ 0
		setWork(state)
		action();
		if(state === "open"){ // 열림이면
			setPercentState(100); // 오른쪽 기준 100프로 열기
			setPercentage1(0); // 왼쪽 기준 0
			setPercentage2(100); // 오른쪽 기준 0
			setWidth(0) // 커튼 크기 0
			handleTransition('no-transition'); 

			handlePostData("control", "open")
			handlePostData("percentControl", 100)
		}else{
			setPercentState(0); // 오른쪽 기준 0프로 닫음
			setPercentage1(100); // 왼쪽 기준 100
			setPercentage2(0); // 오른쪽 기준 0
			setWidth(100)
			handleTransition('no-transition');
		
			handlePostData("control", "close")	

			handlePostData("percentControl", 0)
		
		}
		
	}
	const handleBoth = (value) => {
		setPercentState(value); // 오른쪽 기준
		setPercentage1(100 - value); // 왼쪽
		setPercentage2(value); // 오른쪽
		setWidth(100 - value)
	
		handleTransition('no-transition')
		action();

		handlePostData("percentControl", value)
	
	}

	const handleTransition = (type, value) => {
		if(type === "transition"){
			document.getElementsByClassName('input-range__slider-container')[0].style.transitionDuration = '0.1s'; // 왼쪽 주황색이 목적지까지 가는 시간
			document.getElementsByClassName('input-range__slider-container')[1].style.transitionDuration = '0.1s'; // 오른쪽 주황색이 목적지까지 가는 시간
			document.getElementsByClassName('input-range__slider')[0].style.transitionDuration = '0.3s';
			document.getElementsByClassName('input-range__slider')[1].style.transitionDuration = '0.3s';
			document.getElementsByClassName('curtain-left')[0].style.transitionDuration = '0.5s'; // 왼쪽 커튼이 목적지까지 가는 시간
			document.getElementsByClassName('curtain-right')[0].style.transitionDuration = '0.5s'; // 오른쪽 커튼이 목적지까지 가는 시간
		} 
		else{ // no-transition일 경우
			document.getElementsByClassName('input-range__slider-container')[0].style.transitionDuration = '1s'; // 왼쪽 주황색이 목적지까지 가는 시간
			document.getElementsByClassName('input-range__slider-container')[1].style.transitionDuration = '1s'; // 오른쪽 주황색이 목적지까지 가는 시간
			document.getElementsByClassName('input-range__slider')[0].style.transitionDuration = '5s'; // 변경해도 달라지는게 없음
			document.getElementsByClassName('input-range__slider')[1].style.transitionDuration = '5s'; // 변경해도 달라지는게 없음
			document.getElementsByClassName('curtain-left')[0].style.transitionDelay = '0'; // 열릴때까지 딜레이
			document.getElementsByClassName('curtain-right')[0].style.transitionDelay = '0'; // 열릴때까지 딜레이
			document.getElementsByClassName('curtain-left')[0].style.transitionDuration = '0.5s'; // 왼쪽 커튼이 목적지까지 가는 시간
			document.getElementsByClassName('curtain-right')[0].style.transitionDuration = '0.5s'; // 오른쪽 커튼이 목적지까지 가는 시간
		}

	}
	const springwidth = useSpring({
	from: {width:`calc(${width > 10 ? (width / 2) : "5"}% - 5px)`},
	to: async next =>{ await next({width:`calc(${width > 10 ? (width / 2) : "5"}% - 5px)`})}});
	return (
		<section className="device-setting-body curtain-wrap">
			<div className="device-display curtain">
				<div className="display">
					<div className="curtain-setting">
						{/** 왼쪽 퍼센트 조절 바 */}
						<InputRange
							maxValue={100}
							minValue={0}
							onChangeStart={()=>action()}
							value={percentage1}
							onChange={handleCurtain1} 
							onChangeComplete={handleComplete1}
						/>
						{/** 오른쪽 퍼센트 조절 바*/}
						<InputRange
							maxValue={100}
							minValue={0}
							onChangeStart={()=> action()}
							value={percentage2}
							onChange={handleCurtain2} 
							onChangeComplete={handleComplete2}
						/>
							
					</div>
					<div className="curtain-images">
						{/**<div className="curtain-wrap curtain-left" style={{width:`calc(${width > 10 ? (width / 2) : "5"}% - 5px)`}}>*/}
						<animated.div className="curtain-wrap curtain-left" style={{
							width: springwidth.width,}}>
							{/** p 하나당 커튼 하나 */}
							<p></p>
							<p></p>
							<p></p>
							<p></p>
							<p></p>
						</animated.div>
						<animated.div className="curtain-wrap curtain-right" style={{
							width: springwidth.width,}}>
							<p></p>
							<p></p>
							<p></p>
							<p></p>
							<p></p>
						</animated.div>
					</div>
					<p className="curtain-percentage">{percentState}%</p>
				</div>
			</div>
			<div className="device-control-wrap">
				<div className="curtain-split-percentage">
					<p onClick={()=> handleBoth(0)}>0%</p>
					<p onClick={()=> handleBoth(20)}>20%</p>
					<p onClick={()=> handleBoth(50)}>50%</p>
					<p onClick={()=> handleBoth(70)}>70%</p>
					<p onClick={()=> handleBoth(100)}>100%</p>
				</div>
				<div className="curtain-control">
					<p onClick={()=>handleWork('open')}>
						<strong><CurtainIcon type="open"/></strong>
						<span>열기</span>
					</p>
					<p onClick={()=>handleWork('close')}>
						<strong><CurtainIcon type="close"/></strong>
						<span>닫기</span>
					</p>
				</div>
			</div>

		
		</section>
	);
}

export default CurtainType;